export const getdeviceUuid = async () => {
  const equipment = useEquipmentStore();

  let deviceUuid = localStorage.getItem("deviceUuid");
  if (deviceUuid) return deviceUuid;
  deviceUuid = await generateUUID();
  if (deviceUuid) {
    localStorage.setItem("deviceUuid", deviceUuid);
  }
  return deviceUuid;

  // if (equipment.webviewPlatform === WEBVIEW_PLATFORM.NONE) {
  //   let deviceUuid = localStorage.getItem("deviceUuid");
  //   if (deviceUuid) return deviceUuid;
  //   deviceUuid = await generateUUID();
  //   if (deviceUuid) {
  //     localStorage.setItem("deviceUuid", deviceUuid);
  //   }
  //   return deviceUuid;
  // } else {
  //   try {
  //     const res = await native_GetDeviceId();
  //     return res?.data;
  //   } catch (error) {
  //     return "";
  //   }
  // }
};
